module.exports = __webpack_public_path__ + "components/app-store/static/s3-76ba2b8b1e95351b1ed66a9d98d1f7b9.jpg";